import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Modal, ModalBody, ModalFooter } from '@contrast-security-inc/design-system-popovers'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { MultiSelect } from '@contrast-security-inc/design-system-inputs'
import { Tag } from '../../types'

type Props = Readonly<{
  title: string
  isOpen: boolean
  initialAvailableTags: Tag[]
  initialSelectedTags: Tag[]
  onCancel: () => void
  onConfirm: (selectedTags: Tag[]) => void
}>

export const TagModal = ({
  initialAvailableTags = [],
  initialSelectedTags = [],
  title,
  isOpen,
  onCancel,
  onConfirm
}: Props) => {
  const { formatMessage } = useIntl()
  const [tags, setTags] = useState<Tag[]>([])

  const addTagsTitle = formatMessage({ id: 'title_addTags' })

  useEffect(() => {
    return () => {
      // Cleanup
      setTags([])
    }
  }, [])

  const handleConfirm = () => {
    onConfirm(tags)
  }

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} size="lg" variant="info">
      <ModalBody>
        <MultiSelect<Tag>
          AllowCreateProps={{
            allowCreate: true,
            label: `(${formatMessage({ id: 'title_createTag' })})`
          }}
          label={addTagsTitle}
          initialSelectedItems={initialSelectedTags}
          items={initialAvailableTags}
          aria-label={addTagsTitle}
          itemToString={(item) => (item ? item.name : '')}
          onChange={(_, value) => value && setTags(value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={onCancel}>
          {formatMessage({ id: 'action_cancel' })}
        </Button>
        <Button onClick={handleConfirm}>{formatMessage({ id: 'action_save' })}</Button>
      </ModalFooter>
    </Modal>
  )
}
